import { useState } from "react";
import { useTranslation } from "react-i18next";
import { readableJsonText } from "../../../shared/formatting/readableJson";
import SourceView from "../../../ui/content/source/SourceView";

/** Content of a schema without a table editor: JSON, taken over only while it parses. */
export default function JsonContentEditor({ value, onChange }: { value: unknown; onChange: (value: unknown) => void }) {
  const { t } = useTranslation();
  const [text, setText] = useState(() => readableJsonText(value));
  const [invalid, setInvalid] = useState(false);
  return (
    <SourceView
      label={t("authoring.artifact.json")}
      language="json"
      value={text}
      presentation="full"
      maxHeight={420}
      error={invalid ? t("authoring.artifact.jsonInvalid") : undefined}
      onChange={(next) => {
        setText(next);
        try {
          onChange(JSON.parse(next));
          setInvalid(false);
        } catch {
          setInvalid(true);
        }
      }}
    />
  );
}
